import React, { useEffect } from 'react'
import qs from 'query-string'

import useWindowDimensions from '@hooks/useWindowDimensions.js'
import { useState } from 'react'

const options = [
    {
        label: 'Featured',
        value: 'featured',
    },
    {
        label: 'New Arrivals',
        value: 'new-arrivals',
    },
    // {
    //     label: 'Best Selling',
    //     value: 'best-selling',
    // },
    {
        label: 'Alphabetical: A–Z',
        value: 'a-z',
    },
    {
        label: 'Alphabetical: Z–A',
        value: 'z-a',
    },
    {
        label: 'Price: Low to High',
        value: 'low-high',
    },
    {
        label: 'Price: High to Low',
        value: 'high-low',
    },
]

const SortBy = React.memo(({ sortBy, handleSort }) => {
    const [sortVal, setSortVal] = useState(sortBy)

    useEffect(() => {
        const parsed = qs.parse(window.location.search)
        if (parsed['sort']) {
            const sortValue = parsed['sort']
            setSortVal(sortValue)
            handleSort(sortValue)
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className='sortby-outer'>
            <div
                className={`sortby-inner p-3 lg:p-1 w-full lg:w-[200px] xl:w-[220px] border border-oat rounded-sm text-sm`}
            >
                <select
                    className='select-sort w-full text-sm xl:text-base'
                    value={sortBy}
                    onChange={({ target: { value } }) => handleSort(value)}
                    aria-label='Sort by'
                >
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    )
})

export default SortBy
